<!-- 缴费接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructureForThirdPark"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkingCode": "180410135558832886170666",
          "chargeDate": "20180411135558",
          "payDate": "20180411135658",
          "actPayCharge": "3.2",
          "reliefCharge": "1.2",
          "payOrigin": "3",
          "payOriginRemark": "微信",
          "paymentMode": "0",
          "paymentModeRemark": "0",
          "billCode": "0",
          "couponList": "",
          "otherAttr": {
            "chargeBillNumber": "2019010416572209697841",
            "onlineSearch": 1,
            "traderCouponList": [{
              "isValid": true,
              "traderCouponGrantSn": "BWQDN1O4S3P",
              "traderCouponValue": 1.00
            }, {
              "isValid": true,
              "traderCouponGrantSn": "BWQDN1O4S3O",
              "traderCouponValue": 1.00
            }],
            "payQrCode": "",
            "timeoutLength": 0,
            "chargeTime": "2019-01-04 16:57:21",
            "isCanUse": true,
            "carChargeType": 1,
            "end": "20190104165721",
            "carChargeDesc": "临时车",
            "parkAmount": 6.0,
            "begin": "20190104164914"
          },
          "traderCouponList": [{
            "isValid": true,
            "traderCouponGrantSn": "BWQDN1O4S3P",
            "traderCouponValue": 1.00
          }, {
            "isValid": true,
            "traderCouponGrantSn": "BWQDN1O4S3O",
            "traderCouponValue": 1.00
          }]
        },
        responseCode: {
          "data": {
            "parkCode": "2KKN6111",
            "timeoutLength": 2,
            "ydtBillCode": "2017112416141742352669"
          },
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动同步用户缴费信息到第三方车场接入系统，实现车辆行驶至出口后，道闸自动抬杆放行",
          sdkcondition: "cmd=payFeeForThi",
          httpcondition: this.commonUrls.third+"payFeeForThi",
          precondition: "无",
          fitSystem: "第三方停车场",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          frequency:"实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
              { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
              { info1: 'chargeDate', info2: '是', info3: 'String', info4: '计费时间，yyyyMMddHHmmss' },
              { info1: 'payDate', info2: '是', info3: 'String', info4: '支付时间，yyyyMMddHHmmss' },
              { info1: 'actPayCharge', info2: '是', info3: 'Decimal', info4: '车主实付，元' },
              { info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源（<url>参考附录:/Api/appendixData</url>）' },
              { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
              { info1: 'paymentMode', info2: '是', info3: 'int', info4: '支付方式（<url>参考附录:/Api/appendixData</url>）' },
              { info1: 'paymentModeRemark', info2: '否', info3: 'String', info4: '支付方式备注' },
              { info1: 'billCode', info2: '是', info3: 'String', info4: '第三方系统缴费订单号，每条账单唯一（缴费失败，再次缴费时，该账单号要与首次缴费的一致），用于重复同步时判断重复和对账（不超过30位）' },
              { info1: 'couponList', info2: '否', info3: 'JsonArray', info4: '缴费优惠金额，可配合查费时的查询优惠使用（可直接将查费接口响应couponList赋予此值）' },
              { info1: 'otherAttr', info2: '是', info3: 'JSONObject', info4: '额外信息，缴费时传回，用于扩充其他需要的信息。现有一属性，券列表' },
              { info1: 'traderCouponList ', info2: '否', info3: 'JsonArray', info4: '电子券优惠' }
            ]
          }, {
            titleName: 'couponList：（目前只支持传输一个）注意缴费时 优惠中的couponValue+actPayCharge=查费返回的shouldPayValue',
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠名称' },
              { info1: 'couponValue', info2: '是', info3: 'Decimal', info4: '抵扣金额' },
              { info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠编码' },
              { info1: 'reliefType', info2: '是', info3: 'int', info4: '减免类型，券类型(0:免费券,1:金额扣减券,费减免固定金额结算,2:金额折扣券,车费折扣减免结算,3:金额固定值券,车费按券的固定值结算,4:时间券,时间减免后再按车费结算,5:不同计价券,按不同计价规则车费结算)' },
              { info1: 'faceValue', info2: '是', info3: 'String', info4: '面值，金额填元,折扣填0~1,时间填分钟' }
            ]
          },
            {
              titleName: 'otherAttr部分参数说明',
              tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
              td: [
                { info1: 'timeoutLength', info2: '否', info3: 'int', info4: '剩余免费时长，单位秒;VEMS2.13级以上版本支持' },
                { info1: 'traderCouponList', info2: '否', info3: 'JsonArray', info4: '电子券优惠' },
              ]
            },
            {
              titleName: 'traderCouponList：对应查询时的电子券优惠响应',
              tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
              td: [
                { info1: 'isValid', info2: '是', info3: 'Boolean', info4: '是否可用' },
                { info1: 'traderCouponGrantSn', info2: '否', info3: 'JsonArray', info4: '电子券优惠' },
                { info1: 'traderCouponValue', info2: '否', info3: 'Decimal', info4: '券优惠金额。字段类型视券类型确定' },
              ]
            }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'thirdBillCode', info2: '是', info3: 'String', info4: '第三方车场停车账单编号' },
              { info1: 'timeoutLength', info2: '否', info3: 'int', info4: '缴费后免费时长，单位秒' }
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/common/payFeeForThi.vue